import { render, staticRenderFns } from "./MsSplitButtonFW.vue?vue&type=template&id=c7d66282&scoped=true"
import script from "./MsSplitButtonFW.vue?vue&type=script&lang=js"
export * from "./MsSplitButtonFW.vue?vue&type=script&lang=js"
import style0 from "./MsSplitButtonFW.vue?vue&type=style&index=0&id=c7d66282&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7d66282",
  null
  
)

export default component.exports